// Format number with k/m suffixes
export const formatNum = (n) => {
  if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'm';
  if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  return n.toLocaleString();
};

// Format percentage
export const formatPercent = (value) => {
  if (value >= 0.9999) return '99.99%';
  if (value < 0.0001) return '<0.01%';
  if (value < 0.01) return (value * 100).toFixed(2) + '%';
  if (value < 0.1) return (value * 100).toFixed(2) + '%';
  return (value * 100).toFixed(1) + '%';
};

// Parse price string to number
export const parsePrice = (str) => {
  if (!str) return NaN;
  const clean = str.replace(/,/g, '').replace(/\s/g, '');
  const num = parseInt(clean);
  return isNaN(num) ? NaN : num;
};

// Clamp value between min and max
export const clamp = (value, min, max) => {
  return Math.max(min, Math.min(max, value));
};
